//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PRAMSCORE",
  data() {
    return {
      form: {
        value1: "0",
        value2: "0",
        value3: "",
        value4: "",
        value5: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "正常" },
        { value: "1", name: "肺底部减少" },
        { value: "2", name: "全肺减少" },
        { value: "3", name: "无进气/很少进气" },
      ],
      dataList1: [
        { value: "0", name: "无" },
        { value: "1", name: "仅呼气" },
        { value: "2", name: "呼气和吸气" },
        { value: "3", name: "无需听诊器即可听到声音/无声胸腔，最低限度的空气进入" },
      ],
     
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        result = (form.value1 ? 2 : 0 ) + 
        (form.value2 ? 2 : 0 ) + 
        form.value3 + 
        form.value4 + 
        (form.value5 >= 95 ? 0 :form.value5 >=92 && form.value5 <= 94 ? 1 :2  )
        self.hasScore = true;

        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/PRAMSCORE.vue